import CircularProgress from '@material-ui/core/CircularProgress';
import { Box, Button, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { useAppSelector } from '../reduxhooks';
import OverlayComponentChoice from './OverlayComponentChoice';
import OverlayComponentTitle from './OverlayComponentTitle';
import { useEffect } from 'react';
import React from 'react';
import { ClothingMeasurementDetailPanel, getClothingMeasurementsRuler, getClothingMeasurementsSubtext } from './OverlayViewGenerateMeasureMethod3Favorite1ModifySize';
import { BodyMeasurements, CalculateClothingMeasurementsFromBodyMeasurements, ClothingMeasurementDetail, ClothingMeasurementDetailList, ClothingMeasurements, ClothingMeasurementsKey, ClothingType, FitType, GetKey2CategoryClothingSizeMeasurementValues, RoundClothingMeasurementsToHalfPoint } from 'common-ts/dist/models/UserMeasurements';
import { RegularSizeValue } from 'common-ts/dist/models/Cart';
import { Player } from '@lottiefiles/react-lottie-player';

const useStyles = makeStyles((theme: Theme) =>
createStyles({
}),
);

interface Props {
  clothingType: ClothingType
  fitType: FitType
  currentMeasurements: BodyMeasurements
  adjustedMeasurements: BodyMeasurements
  isBody?: boolean
  onBack: () => void
  onOk: () => void
}

export default function PageCheckoutMeasurements({ clothingType, fitType, isBody, currentMeasurements, adjustedMeasurements, onBack, onOk }: Props) {
  const classes = useStyles();


  if (!clothingType) {
    return null;
  }

  const key2ClothSizeValues = GetKey2CategoryClothingSizeMeasurementValues(clothingType, 
    fitType, false);
  const curClothingMeas = RoundClothingMeasurementsToHalfPoint(CalculateClothingMeasurementsFromBodyMeasurements(
    clothingType, 
    fitType,
    currentMeasurements, RegularSizeValue.L));
  const adjClothingMeas = RoundClothingMeasurementsToHalfPoint(CalculateClothingMeasurementsFromBodyMeasurements(
    clothingType, 
    fitType,
    adjustedMeasurements, RegularSizeValue.L));

  const differencesDict: {[key:string]: {
    keyString: string
    originalValue: number
    adjustedValue: number
  }} = {};
  
  for (let clothKey of Object.keys(curClothingMeas)) {
    if (adjClothingMeas[clothKey as keyof ClothingMeasurements] !== curClothingMeas[clothKey as keyof ClothingMeasurements]) {
      differencesDict[clothKey] = {
        keyString: clothKey,
        originalValue: curClothingMeas?.[clothKey as keyof ClothingMeasurements] ?? 1,
        adjustedValue: adjClothingMeas?.[clothKey as keyof ClothingMeasurements] ?? 1,
      }
    }
  }

  return (
    <>
      <Box style={{
        padding: isBody ? "0px 36px" : "0px 20px",
        // marginTop: '5em',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <Box style={{
          width: '100%',
          overflow: 'clip',
          margin: '0px 0px 0px',
        }}>
          <Player
            key='regular-animation'
            autoplay
            loop
            src={'https://studiosclo.uk/general/Size_Serviceability_Loop_No_Glow_checkmark.json'}
            style={{
              width: '80%',
              marginLeft: '10%',
              marginTop: '-4%',
              marginBottom: '-7%',
            }}
          >
          </Player>
        </Box>
        <img src={isBody ? 'https://studiosclo.uk/general/penyesuaian-ukuran-badan.svg' : 'https://studiosclo.uk/general/penyesuaian-ukuran-baju.svg'} alt='dsf' style={{
          width: '100%', margin: '0% 0% 6%',
        }}/>
        {
          Object.keys(differencesDict).map((objKey) => {
            const measurementName = ClothingMeasurementDetailList[(objKey as ClothingMeasurementsKey)].clothingMeasurementName;
            return (<Typography style={{fontSize: '14px', fontWeight: 400}}>
              <span style={{fontWeight: 500}}>{measurementName}:</span> {differencesDict[objKey].originalValue} cm ke {differencesDict[objKey].adjustedValue} cm
            </Typography>);
          })
        }
        <Box style={{width: '100%', display: 'flex', justifyContent: 'space-between', margin: '7% 0% 9%'}}>
          <Button style={{
            letterSpacing: '1px',
            fontSize: '12px',
            border: '1px solid black',
            padding: '4px 13px 2px',
            borderRadius: '50px',
          }} onClick={onBack}>KEMBALI</Button>
          <Button style={{
            letterSpacing: '1px',
            fontSize: '12px',
            padding: '4px 13px 2px',
            borderRadius: '50px',
            color: '#fff',
            backgroundColor: '#232323',
          }} onClick={onOk}>SESUAIKAN</Button>
        </Box>
      </Box>
    </>
  );
}